import type { GQInvoiceItem } from "@/admin/reports/ReportsTable.tsx";
import { UpdateInvoiceStatusBlock } from "@/admin/reports/UpdateInvoiceStatusBlock.tsx";
import { Toolbar } from "@/components/Toolbar.tsx";
import { DownloadPdf } from "@/modules/billing/invoice/DownloadPdf.tsx";
import { hasPdfDownload } from "@/modules/billing/invoice/invoiceLogic.tsx";

export function InvoiceToolbar({ item }: { item: GQInvoiceItem }) {
    return (
        <Toolbar>
            <UpdateInvoiceStatusBlock item={item} />
            {hasPdfDownload(item) && <DownloadPdf item={item} isAdmin />}
        </Toolbar>
    );
}
